import React from 'react';
import classnames from 'classnames';
import { useToggle } from 'ahooks';
import { Form } from 'tea-component';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import TriggerFoldBtn from '@gp/components/TriggerFoldBtn';
import TextAreaMore from '@gp/components/TextAreaMore';
import { formatDateStr, getTencentAvatarSrc } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';

import type { IBaseProps } from '@home/types/common';
import type { IMilestoneHistory } from '@gp/types/milestones';

interface IMilestoneHistoriesProps extends IBaseProps {
  visible?: boolean;
  isShowAllContent?: boolean;
  histories?: IMilestoneHistory[] | null;
}

const MilestoneHistories: React.FC<IMilestoneHistoriesProps> = (props) => {
  const { style, className, visible: visibleProps = false, isShowAllContent = false, histories = [] } = props;

  const showHistories = Array.isArray(histories) && histories.length > 0;

  const [visible, { toggle: toggleVisible }] = useToggle(!!visibleProps);

  return (
    <Form.Item
      style={style}
      className={classnames('', className)}
      label={
        <div className="dbg-milestone-form-label">
          Milestone History{' '}
          <TriggerFoldBtn
            className="dbg-milestone-form-label-show"
            foldBubble="Expand by History"
            unFoldBubble="Fold by History"
            state={visible}
            onClick={() => {
              toggleVisible();
            }}
          />
        </div>
      }
    >
      {visible && (
        <Form.Text className="dbg-milestone-form-text">
          {showHistories || '-'}
          {showHistories &&
            histories.map((history, historyIdx) => {
              const {
                date_confirm: dateConfirm,
                date,
                modify_personnel: modifyPersonnel,
                update_time: updatedTime,
              } = history || {};
              const formattedDate = formatMilestoneDateByStatus(date, dateConfirm) || '-';
              const formattedUpdatedPersonnel = modifyPersonnel || '';
              const formattedUpdatedTime = formatDateStr(updatedTime, 'YYYY-MM-DD HH:mm') || '-';
              return (
                <div key={historyIdx} className="dbg-milestone-form-item">
                  <div className="dbg-history-date">Updated Milestone Date: {formattedDate}</div>
                  <TextAreaMore
                    className="gp-word-break-word gp-wang-edit-content dbg-history-info"
                    isJsComputed
                    isMustNoButton
                    type="ellipsis"
                    lineHeight={22}
                    ellipsisLineClamp={2}
                    textSize={14}
                    text={history?.reason || '-'}
                    isShowAllContent={isShowAllContent}
                    // getIsFold={(v) => {
                    //   historyIdx === 0 && setRecordsIsOverflow(v, record, records, setRecords);
                    // }}
                  />
                  <div className="dbg-history-item">
                    <GeneralImageNew
                      className="dbg-history-item-img"
                      domain="user"
                      width={20}
                      height={20}
                      src={getTencentAvatarSrc(formattedUpdatedPersonnel)}
                    />
                    <span className="dbg-history-item-name">{formattedUpdatedPersonnel || '-'}</span>
                    <span className="dbg-history-item-bar">updated on</span>
                    <span className="dbg-history-item-date">{formattedUpdatedTime}</span>
                  </div>
                </div>
              );
            })}
        </Form.Text>
      )}
    </Form.Item>
  );
};

export default MilestoneHistories;
